import { BundleProduct, isBundleProduct } from "../lib/models/Products";

import { FELICETTE_PRODUCTS } from "../lib/models/Products";
import { toTitleCase } from "../util/strings";

const allStyles = ["Thin", "Light", "Regular", "Medium", "Bold", "ExtraBold"];
const textFontFamily = "ST Felicette Regular";

const Felicette = {
  name: "Felicette",
  subtitle: "A sans-serif with charm.",
  accentColor: "pink",
  secondaryAccentColor: "blue",
  fineTextColor: "fedblue",
  defaultStyle: "Felicette Script Medium",
  styleGroups: [
    {
      name: "Felicette",
      fontStyles: FELICETTE_PRODUCTS.filter((product) =>
        [0, 1, 2, 3, 4, 5].includes(product.id)
      ),
    },
    {
      name: "Felicette Script",
      fontStyles: FELICETTE_PRODUCTS.filter((product) =>
        [6, 7, 8, 9, 10, 11].includes(product.id)
      ),
    },
  ],
  stylePurchaseBundles: FELICETTE_PRODUCTS.filter(
    isBundleProduct
  ) as BundleProduct[],
  textFontFamily,
  headerFontFamily: "ST Felicette Bold",
  specimenRows: [
    "Mae Jemison",
    "Kalpana Chawla",
    "José Hernandez",
    "Ellen Ochoa",
    "Guion S. Bluford",
    "Chawla Koichi",
  ]
    .map((name, i) => {
      return {
        fontName: `Felicette ${toTitleCase(allStyles[i])}`,
        fontFamily: `ST Felicette ${allStyles[i]}`,
        fontText: name,
        group: "Felicette",
      };
    })
    .concat(
      [
        "Mae Jemison",
        "Kalpana Chawla",
        "José Hernandez",
        "Ellen Ochoa",
        "Guion S. Bluford",
        "Chawla Koichi",
      ].map((name, i) => {
        return {
          fontName: `Felicette Script ${toTitleCase(allStyles[i])}`,
          fontFamily: `ST Felicette Script ${allStyles[i]}`,
          fontText: name,
          group: "Felicette Script",
        };
      })
    ),
  info: {
    description: (
      <>
        <p style={{ fontFamily: textFontFamily }}>
          Friendly and contemporary, Felicette is a sans-serif with charm. It is
          fitting on occasions that call for a friendly face, while not
          compromising on the need for a clean-cut geometric sans. It's elegant,
          lovable and good-looking — just like Félicette, its namesake Parisian
          cat who was sent into space!
        </p>
        <p style={{ fontFamily: textFontFamily }}>
          In future releases, the upright family will be accompanied by a
          script-style family, rather than the traditional sloped or italic
          styles, to further emphasize its friendliness.
        </p>
      </>
    ),
    languagesSupported:
      "Albanian, Asu, Basque, Bemba, Bena, Breton, Catalan, Chiga, Colognian, Cornish, Croatian, Czech, Danish, Dutch, English, Estonian, Faroese, Filipino, Finnish, French, Friulian, Galician, Ganda, German, Gusii, Hungarian, Inari, Sami, Indonesian, Irish, Italian, Jola-Fonyi, Kabuverdianu, Kalenjin, Kinyarwanda, Koyra, ChiiniLatvian, Koyraboro, Senni, Lithuanian, Lower Sorbian, LuoLuxembourgish, Luyia, Machame, Makhuwa-Meetto, Makonde, Malagasy, Maltese, Manx, Marshallese, Moldavian, Morisyen, North Ndebele, Northern Sami, Norwegian Bokmål, Norwegian,  Nynorsk, Nyankole, Oromo, Polish, Portuguese, Quechua, Romanian, Romansh, Rombo, Rundi, Rwa, Samburu, Sango, Sangu, Scottish, Gaelic, Sena, Serbian, Shambala, Shona, Slovak, Soga, Somali, Spanish, Swahili, Swedish, Swiss, German, Taita, Tasawaq, Teso, Turkish, Upper Sorbian, Uzbek (Latin), Volapük, VunjoWalser, Welsh, Western Frisian, Zarma, Zulu.",
    collection: "ST Felicette",
    designers: "Lynne Yun, Cris Hernandez, & Tamara Segura",
    release: "2022",
    numWeights: 6,
    numStyles: 12,
    version: "2.1",
    fileFormats: ".otf, .ttf, .woff2",
  },
};

export default Felicette;
